import { ISelectItem } from '@lla-platform/core/core-ui'

// Values match the BE C# enum member names — that's what JsonStringEnumConverter
// emits on the wire, so the FE can compare/round-trip without translation.
export enum UsafAutoOrderOutcome {
  Ordered = 'Ordered',
  Skipped = 'Skipped'
}

export enum UsafAutoOrderSkipReason {
  SurplusStock = 'SurplusStock',
  DeliveryTooFar = 'DeliveryTooFar',
  NoDeliveryEstimate = 'NoDeliveryEstimate',
  NoStock = 'NoStock',
  UnknownLineCode = 'UnknownLineCode',
  ExceedsCap = 'ExceedsCap',
  StockCheckFailed = 'StockCheckFailed',
  SubmitRejected = 'SubmitRejected',
  SubmitFailed = 'SubmitFailed',
  ExcludedByUser = 'ExcludedByUser'
}

export enum UsafAutoOrderTrigger {
  Invoice = 'Invoice',
  DailyRefill = 'DailyRefill',
  ManualRefill = 'ManualRefill'
}

export const UsafAutoOrderTriggerLabels: Record<string, string> = {
  [UsafAutoOrderTrigger.Invoice]: 'Invoice',
  [UsafAutoOrderTrigger.DailyRefill]: 'Daily Refill',
  [UsafAutoOrderTrigger.ManualRefill]: 'Manual Refill'
}

export const UsafAutoOrderTriggerItems: ISelectItem[] = Object.entries(UsafAutoOrderTriggerLabels).map(
  ([value, label]) => ({ label, value })
)

export const UsafAutoOrderSkipReasonLabels: Record<string, string> = {
  [UsafAutoOrderSkipReason.SurplusStock]: 'Surplus Stock',
  [UsafAutoOrderSkipReason.DeliveryTooFar]: 'Delivery Too Far',
  [UsafAutoOrderSkipReason.NoDeliveryEstimate]: 'No Delivery Estimate',
  [UsafAutoOrderSkipReason.NoStock]: 'No Stock',
  [UsafAutoOrderSkipReason.UnknownLineCode]: 'Unknown Line Code',
  [UsafAutoOrderSkipReason.ExceedsCap]: 'Exceeds Cap',
  [UsafAutoOrderSkipReason.StockCheckFailed]: 'Stock Check Failed',
  [UsafAutoOrderSkipReason.SubmitRejected]: 'Order Rejected',
  [UsafAutoOrderSkipReason.SubmitFailed]: 'Submit Failed',
  [UsafAutoOrderSkipReason.ExcludedByUser]: 'Excluded by User'
}

export const UsafAutoOrderOutcomeItems: ISelectItem[] = [
  { label: 'Ordered', value: UsafAutoOrderOutcome.Ordered },
  { label: 'Skipped', value: UsafAutoOrderOutcome.Skipped }
]

export const UsafAutoOrderSkipReasonItems: ISelectItem[] = Object.entries(
  UsafAutoOrderSkipReasonLabels
).map(([value, label]) => ({ label, value }))
